import { createAsyncAction } from 'typesafe-actions'
import { ContactState } from '../../types'
import { Failure, Request, Success } from './types'
import { toast } from '@/helpers/toast/toast.helper'
import { t } from 'i18next'

export const updateContactAction = createAsyncAction(
  '@contact/UPDATE_CONTACT_REQUEST',
  '@contact/UPDATE_CONTACT_SUCCESS',
  '@contact/UPDATE_CONTACT_FAILURE'
)<Request, Success, Failure>()

const request = (state: ContactState): ContactState => ({
  ...state,
  isLoadingUpdateContact: true
})

const success = (state: ContactState): ContactState => {
  toast({ type: 'success', message: t('translation:contactSuccessfullyUpdated') })
  return {
    ...state,
    isSuccessUpdateContact: true,
    isLoadingUpdateContact: false,
    isErrorOnUpdateContact: false
  }
}

const failure = (state: ContactState): ContactState => {
  toast({ type: 'error', message: t('translation:contactUpdateError') })
  return {
    ...state,
    isLoadingUpdateContact: false,
    isErrorOnUpdateContact: true
  }
}

export const updateContactHandle = { asyncAction: updateContactAction, request, success, failure }
